<div
  class="flex w-full max-w-lg flex-grow flex-col items-center justify-center gap-8 px-container-padding-mobile text-center"
>
  <!-- Hero Title -->
  <section class="group relative">
    <div
      class="absolute -inset-4 rounded-full bg-primary/20 opacity-50 blur-3xl transition-opacity group-hover:opacity-70"
    ></div>
    <div class="relative">
      <h2
        class="neon-glow-pink mb-2 bg-gradient-to-br from-primary via-white to-secondary-fixed-dim bg-clip-text font-display-xl text-display-xl uppercase leading-tight tracking-tighter text-transparent"
      >
        Quem sou eu?
      </h2>
      <div class="neon-glow-pink mx-auto h-1 w-24 rounded-full bg-primary"></div>
    </div>
  </section>

  <!-- Bento Hero Module -->
  <div class="glass-panel relative flex w-full flex-col gap-8 overflow-hidden rounded-xl p-8 shadow-2xl">
    <div class="absolute top-0 right-0 p-2 opacity-20">
      <span class="material-symbols-outlined rotate-12 text-[120px]">quiz</span>
    </div>

    <div class="relative z-10 flex flex-col items-center gap-4">
      <app-mode-card class="w-full" icon="play_arrow" label="Modo Solo" variant="primary" (click)="onSoloClick()" />
      <app-mode-card
        class="w-full"
        icon="calendar_month"
        label="Desafio Diário"
        subtitle="Um personagem novo a cada dia"
        variant="secondary"
        (click)="onDailyClick()"
      />
    </div>
  </div>
</div>
